import { Subject } from "rxjs";

export const FirebaseTokenRegisterSubject = new Subject<any>();